import React, { useState, useEffect } from "react"
import { Container, Row, Col, CardBody, Card, Button, CardTitle, CardText  } from "reactstrap"
import axios from "axios";
import Select from "react-select"
import * as url from "../../helpers/url_helper"
import { Config } from "helpers/backend_helper";


const RecordComplaint = () => {

  const [complaintCategories, setComplaintCategories] = useState(['Leakage', 'Burst','Over-billing','Water Quality Problem', 'No Bills', 'No Water']);
  const [submitted, setSubmitted] = useState(false)

  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [supplyNo, setSupplyNo] = useState('')
  const [category, setCategory] = useState('')
  const [details, setDetails] = useState('')
  const [categoryOptions, setCategoryOptions] = useState([])
  
  const handleSubmitComplaint = () => {
    //setSubmitted(true)

    const data = {
        "name": name,
        "phone": phone,
        "email" : email,
        "snumber": supplyNo,
        "category": category,
        "details": details
    }
    console.log(JSON.stringify(data))
  }

  useEffect(()=>{
    axios.get(url.COMPLAINTCATEGORIES, Config).then((r)=>{
      let options = []
      r.data.map((d)=>{
        options.push({value:d.id, label:d.name})
      })
      setCategoryOptions(options)
    })
  },[])
  return (
    <React.Fragment>
        {!submitted && (
            <Card>
                <CardBody>
                        <Row>
                        <Col md={12}>
                            <div className="mb-3">
                                <label htmlFor="floatingIdInput">Name</label>
                                <input type="text" className="form-control" value={name} onChange={(e)=>setName(e.target.value)} />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label htmlFor="floatingIdInput">Email</label>
                                <input type="email" className="form-control" value={email} onChange={(e)=>setEmail(e.target.value)} />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label htmlFor="floatingIdInput">Phone</label>
                                <input type="tephone" className="form-control" value={phone} onChange={(e)=>setPhone(e.target.value)} />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label htmlFor="floatingIdInput">Customer Supply Number</label>
                                <input type="text" className="form-control" value={supplyNo} onChange={(e)=>setSupplyNo(e.target.value)} />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label htmlFor="floatingIdInput">Complaint Category</label>
                                <Select options={categoryOptions} />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mb-3">
                                <label htmlFor="floatingIdInput">Complaint Details</label>
                                <textarea className="form-control" value={details} onChange={(e)=>setDetails(e.target.value)} />
                            </div>
                        </Col>
                        </Row>
                       
                    <Row>
                        <Col md={6}>
                            <div className="d-grid gap-2">
                                <Button color="primary" type="button" className="btn" onClick={handleSubmitComplaint}>
                                    Submit Complaint
                                </Button>
                            </div>
                        </Col>
            
                    </Row>
                    </CardBody>
                </Card>
        )}
        {submitted && (
            <Card color="success" className="text-white-50">
                <CardBody>
                  <CardTitle className="mb-4 text-white">
                    <i className="mdi mdi-check-all me-3" /> Complaint Received
                  </CardTitle>
                  <CardText>
                    Complaint has been received and concerned persons have been notified to urgently take action. Tracking Number <strong>H52461</strong>
                  </CardText>
                </CardBody>
              </Card>
        )}
    </React.Fragment>
  )
}

export default RecordComplaint